import genererTableauSociete from '@/services/societe/genererTableauSociete';
import transformerSociete from '@/services/societe/societeServerTableDataTransformer';
import { getAll, get } from '@/api/societe';
import transformAgenceToAgenceInfo from '@/services/societe/transformAgenceToAgenceInfo';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import * as allTypes from '../mutation-type';
import * as types from './societe-mutation-type';

function initialState() {
  return {
    societeActiveId: null,
    societeActive: null,
    agenceActive: [],
    societeOfUser: [],
    totalSociete: 0,
    detectChangeSociete: true,
    dataPlatformApiKey: '73157b50-8c2f-11e9-b5d2-d58b63a3b90a',
    societesInformations: [],
    agencesInformations: [],
    societeCourante: null,
    lockMenu: false,
    forceUnlockMenu: false,
    logoAgences: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_AGENCE_ACTIVE](state, agenceActive) {
    state.agenceActive = agenceActive;
  },
  [types.SET_DETECT_CHANGE_SOCIETE](state, detectChangeSociete) {
    state.detectChangeSociete = detectChangeSociete;
  },
  [types.SET_SOCIETE_ACTIVE_ID](state, societeActiveId) {
    state.societeActiveId = societeActiveId;
  },
  [types.SET_SOCIETE_ACTIVE](state, societeActive) {
    state.societeActive = societeActive;
  },
  [types.SET_SOCIETE_OF_USER](state, societeOfUser) {
    state.societeOfUser = societeOfUser;
  },
  [types.SET_INFORMATIONS_SOCIETES](state, societesInformations) {
    state.societesInformations = societesInformations;
  },
  [types.SET_INFORMATIONS_AGENCES](state, agencesInformations) {
    state.agencesInformations = agencesInformations;
  },
  [types.SET_TOTAL_SOCIETES](state, totalCount) {
    state.totalSociete = totalCount;
  },
  [types.SET_SOCIETE_COURANTE](state, societeCourante) {
    state.societeCourante = societeCourante;
  },
  [types.SET_LOCK_MENU](state, lockMenu) {
    state.lockMenu = lockMenu;
  },
  [types.SET_FORCE_UNLOCK_MENU](state, forceUnlockMenu) {
    state.forceUnlockMenu = forceUnlockMenu;
  },
  [types.SET_LOGO_AGENCES](state, logoAgences) {
    state.logoAgences = logoAgences;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async setSocieteOfUser({ commit, getters }, userInformation) {
    commit(types.SET_SOCIETE_OF_USER, await genererTableauSociete(
      userInformation,
      getters.societesInformations,
    ));
  },
  async setSocieteId({ commit, getters }, id) {
    if (id !== null
      && (getters.societeActiveId !== id
      || getters.societeActive === null)) {
      const societe = (await get(id)).data.result;
      commit(types.SET_SOCIETE_ACTIVE, societe);
    }
    commit(types.SET_SOCIETE_ACTIVE_ID, id);
  },
  setDetectChangeSociete({ commit }, detect) {
    commit(types.SET_DETECT_CHANGE_SOCIETE, detect);
  },
  setMultipleAgenceActive({ commit, dispatch }, agences) {
    const agenceActive = [];
    agences.forEach((agence) => {
      agence.selected = true;
      agenceActive.push(agence);
    });
    commit(types.SET_AGENCE_ACTIVE, agenceActive);
    dispatch('loadAgencesLogos', agenceActive);
  },
  async loadSocietes({ commit }, params) {
    const inputServer = transformerSociete(params);
    const response = await getAll(inputServer);
    commit(types.SET_TOTAL_SOCIETES, response.data.result.totalCount);
    commit(types.SET_INFORMATIONS_SOCIETES, response.data.result.items);
    commit(types.SET_INFORMATIONS_AGENCES, transformAgenceToAgenceInfo(response.data.result.items));
    return {};
  },
  async loadAgencesLogos({ commit }, agences) {
    const agencesIds = agences.map(a => a.agenceId);
    const logoAgences = (await pGetAllPieceJointe(
      { elementsId: agencesIds, placeType: PIECE_JOINTE_TYPE_LOGO },
    )).data.result.items;
    commit(types.SET_LOGO_AGENCES, logoAgences);
  },
};

const getters = {
  societeActiveId: state => {
    return state.societeActiveId;
  },
  societeActive: state => {
    return state.societeActive;
  },
  agenceActive: state => {
    return state.agenceActive;
  },
  societeOfUser: state => {
    return state.societeOfUser;
  },
  detectChangeSociete: state => {
    return state.detectChangeSociete;
  },
  dataPlatformApiKey: state => {
    return state.dataPlatformApiKey;
  },
  societesInformations: state => {
    return state.societesInformations;
  },
  agencesInformations: state => {
    return state.agencesInformations;
  },
  totalSociete: state => {
    return state.totalSociete;
  },
  societeCourante: state => {
    return state.societeCourante;
  },
  lockMenu: state => {
    return state.lockMenu;
  },
  forceUnlockMenu: state => {
    return state.forceUnlockMenu;
  },
  logoAgences: state => {
    return state.logoAgences;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
